<template>
  <div class="bed-rail-check">
    <el-card>
      <span>
        If bedrail is
      </span>
      <el-select
        id="bed-rail-select"
        v-close-on-zoom
        :value="state.bedRailState"
        placeholder="Bed Rail Procedure"
        class="bed-rail-select"
        :disabled="readonly"
        @input="bedRailState => setBedRailState(bedRailState)"
      >
        <el-option
          label="Raised"
          value="RAISED"
        />
        <el-option
          label="Lowered"
          value="LOWERED"
        />
      </el-select>
    </el-card>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'bed-rail-check',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        bedRailState: 'RAISED',
      },
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.bedRailState = get(data, 'id') || 'RAISED';
    this.update();
  },
  methods: {
    setBedRailState(bedRailState) {
      this.state.bedRailState = bedRailState;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'BED_RAIL',
        id: this.state.bedRailState,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.bed-rail-check, .el-card {
  width: 100%;
  color: black;
}
</style>
